import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { FlxThemeModule } from '@flowx/angular-theme'
import { FlxButtonComponent } from '@flowx/angular-ui-toolkit'
import { UiFlowBlockedReason, getUiFlowBlockedLabels, startNewUiFlowSession } from '@flowx/core-sdk'

@Component({
  selector: 'flx-ui-flow-access-denied',
  imports: [FlxButtonComponent, FlxThemeModule],
  template: `
    <div
      class="flx-ui-flow-access-denied"
      flxAccessDenied
      data-testid="ui-flow-access-denied"
    >
      <h1 data-testid="ui-flow-access-denied-title">{{ labels().title }}</h1>
      <p data-testid="ui-flow-access-denied-description">{{ labels().description }}</p>
      <button
        [variant]="'fill'"
        (click)="startNewSession()"
        flxButton
        data-testid="ui-flow-access-denied-cta"
      >
        {{ labels().cta }}
      </button>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex: 1 1 auto;
    }
    .flx-ui-flow-access-denied {
      height: 100vh;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      gap: var(--flxTheme-accessDenied-gap, 24px);

      h1 {
        margin: 0;
        font-family: var(--flxTheme-accessDenied-title-fontFamily);
        font-size: var(--flxTheme-accessDenied-title-fontSize, 60px);
        font-weight: var(--flxTheme-accessDenied-title-fontWeight, 700);
        line-height: var(--flxTheme-accessDenied-title-lineHeight, 90px);
        color: var(--flxTheme-accessDenied-titleColor, #1f2937);
      }

      p {
        margin: 0;
        font-family: var(--flxTheme-accessDenied-message-fontFamily);
        font-size: var(--flxTheme-accessDenied-message-fontSize, 18px);
        font-weight: var(--flxTheme-accessDenied-message-fontWeight, 400);
        line-height: var(--flxTheme-accessDenied-message-lineHeight, 28px);
        color: var(--flxTheme-accessDenied-messageColor, #4b5563);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxUiFlowAccessDeniedComponent {
  reason = input<UiFlowBlockedReason | null>('access-denied')

  readonly labels = computed(() => getUiFlowBlockedLabels(this.reason()))

  startNewSession(): void {
    void startNewUiFlowSession()
  }
}
